var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ParseForm',{ref:"bus",attrs:{"formParams":_vm.formParams,"reMountPage":_vm.reMountPage,"opCode":_vm.opCode}})}
var staticRenderFns = []

export { render, staticRenderFns }